
import ServerResponseModel from "./ServerResponseModel";

export default class WsC{

    // adresaServer = 'http://192.168.100.2:4446/api/'

    // adresaMedia = 'http://192.168.100.2:4446/Storage'
    // adresaBackground="http://192.168.100.2:4446/Storage/Backgrounds/"
    // previewRezultate = "http://192.168.100.2:4446/Storage/Chestionare/Preview_rezultate"
    // previewImage = "http://192.168.100.2:4446/Storage/Chestionare/Preview_image"



    adresaServer = 'https://chestionare.totalsoftware.ro/api/'
    adresaMedia = 'https://chestionare.totalsoftware.ro/Storage'
    adresaBackground = "https://chestionare.totalsoftware.ro/Storage/Backgrounds/"
    previewImage = "https://chestionare.totalsoftware.ro/Storage/Chestionare/Preview_image"
    previewRezultate = "https://chestionare.totalsoftware.ro/Storage/Chestionare/Preview_rezultate"
    reactPostRef = 'dh839dnasjddty'

    update = async (tabela, cols, where) =>{

        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'Update'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.where = where
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null , true)

        if(r.Succes){
            return r
        }

    }

    insert = async (tabela, cols) =>{
        let po = this.generatePostObject()

        po.postDataHeader.Scop ='Insert'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null , true)


        // console.log('r :', r);

        if(r.Succes){
            return r
        }
    }


    select = async (tabela, cols , where ) =>{
        let po = this.generatePostObject()

        po.postDataHeader.Scop ='Select'
        po.postDataHeader.Tabela = tabela
        po.columns = cols
        po.where = where
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null , true)

        if(r.Succes){
            return r
        }
    }

    proc = async (procName, parametrii  ) =>{
        let po = this.generatePostObject()

        po.postDataHeader.Scop ='Proc'
        po.postDataHeader.Tabela = procName
        po.columns = parametrii
        po.postDataHeader.Ref = this.reactPostRef

        let r = await this.postToJsTruster(po, null , true)

        

        if(r.Succes){
            return r
        }
    }

    customSelect = async (q, params) =>{
        let po = this.generatePostObject()

        po.postDataHeader.Scop = 'SelectComplex'

        po.custselect = q
        po.custparams = params 
        po.postDataHeader.Ref = this.reactPostRef


        let r = await this.postToJsTruster(po, null , true)

        console.log('r Custom:', r);


        if(r.Succes){
            return r
        }
    }


    finalizeazaChestionar = async (hashId, idHead)=>{

    
    
        
        let addr = `${this.adresaServer}Completator/FinalizareChestionar/?hashIdInvitatie=${hashId}&idHeadChestionar=${idHead}`
          
            
       
        addr = encodeURI(addr)

      

        let r = await fetch(addr)

       

 

        let sR = new ServerResponseModel()

        if(sR.statusCode(r.status)){
            
            
            // console.log('response is ------- :', r);
            return r.json();
        }else{
            console.error('error status code', r)
        }
    

    }

    uploadimage = async (adresa,file, id )=>{


        //adresa = if angajat
        // 

     

    

        let addr = `${this.adresaServer}${adresa}=${id}`


                let formData = new FormData();
                formData.append('file', file);

                addr = encodeURI(addr)

        let fromServer = await fetch(addr,{method:'POST', body:formData})

        let serverResponseAsJson = await fromServer.json()

        // console.log('fromServer :', serverResponseAsJson);

        // if(fromServer.status === 200){
        //    return true
        // }else{
        //     return false
        // }

        return serverResponseAsJson
    
        // let serverResponseAsJson = await fromServer.json()
       
    
    }
   
    
   

    


    raspunsGuest = async (raspuns, tip, hashId, IdHead)=>{
        let postObject = {
            IdRaspuns:raspuns.id,
            NoulRaspuns:raspuns.raspuns,
            IdIntrebare:raspuns.id_intrebare,
            TipIntrebare:tip,
            IdHead:IdHead
        }
    
        
        let addr = `${this.adresaServer}Completator/Raspuns/?hashIdInvitatie=${hashId}`
          
            
        let r = await fetch(addr,{method:'POST',
                                 headers:{'Accept':'application/json',
                                           'Content-Type':'application/json'},
                                 body:JSON.stringify(postObject)       })
    
    
    // console.log('addr :', addr);
    
    let sR = new ServerResponseModel()

    if(sR.statusCode(r.status)){
        
        
        // console.log('response is ------- :', r);
        return r.json();
    }else{
        console.error('error status code', r)
    }
    
    
    
      }


      sendNotification = async (idChestionar,idEvaluare, tip) =>{
        let addr = `${this.adresaServer}notificari/GenerateNotificare/?idchestionar=${idChestionar}&idevaluare=${idEvaluare}&tipNotificare=${tip}`


        // console.log('addr :>> ', addr);
        addr = encodeURI(addr)

        let r = await fetch(addr)


        r = await r.json()

        return r
    }

    postData = async (adresa,postObject,params=null, activeLog=null) => {

        let userData =  this.getUserData();

        // console.log('userData :', userData);
        
       

            if(postObject.postDataHeader.Scop){

                let addr = this.adresaServer + adresa+'?UserToken='+'GnkLzHZdB3A1geiknDDYK8KQYrMTtxu7iq4lJzg9jLO2NZR7OrfOpxLxZf1OpCIh1mdIhLA27RRX8w2Lnb4WycPBENsvbwNL7qfVASni4WQFB4gS38BQ2HPlSNuT/bpKH0gpRV07DjLgrEKuXJzi/odh2pHf3SRdrPKxizxQO/Q0qyECFBajYq67ge+ROiYC/Po9i6Ua1jirwiPGCM2W9NRotx2p/JT6OO81TnY/yVg=' 
                
                if(params){
                    for (let k in params){
                        addr+='&'+k+'='+params[k]
                    }
                }

               addr = encodeURI(addr)

                //TODO: add post object as form data

                let formData = new FormData();
                formData.append('PostData', postObject);
                

                if(activeLog){
                    // console.log('postData --> address = ', addr)
                    // console.log('Object to post = ', postObject)
                }
            
               // let r = await fetch(addr,{headers:{"Content-Type":"application/x-www-form-urlencoded"}, body:String.raw({raw:[formData]}) , method:'POST'})
               let r = await fetch(addr,{
                method:'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                body:JSON.stringify(postObject)  
            })
      
        //  let r = new XMLHttpRequest();
        //  r.open("POST", addr, true);
        //  r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        //  r.send('sssss')



                //let r = await fetch(addr,{headers:{'cacat':'cacat'} ,method:'POST', body:formData})
                let rjs = await r.json()
               // let rjs = await r.text()

                if(activeLog){
                    // console.log('postData --> server response = ', r)
                    // console.log('postData --> response Status :', r.status);
                   
                    // console.log('postData --> readable server response = ', rjs)
                }

                let sR = new ServerResponseModel()

                if(sR.statusCode(r.status)){
                    
                    
                    // console.log('response is ------- :', r);
                    return rjs
                }else{
                    console.error('error status code', r)
                }
            
            
            }
            else{
                console.error('postObject.headerData.Scop is null')
                return null;
            }

            
        
        
    }

    postDataLite = async (adresa,postObject,params=null, activeLog=null) => {

        let userData =  this.getUserData();

        // console.log('userData :', userData);
        
       

            

                let addr = this.adresaServer + adresa+'?UserToken='+'GnkLzHZdB3A1geiknDDYK8KQYrMTtxu7iq4lJzg9jLO2NZR7OrfOpxLxZf1OpCIh1mdIhLA27RRX8w2Lnb4WycPBENsvbwNL7qfVASni4WQFB4gS38BQ2HPlSNuT/bpKH0gpRV07DjLgrEKuXJzi/odh2pHf3SRdrPKxizxQO/Q0qyECFBajYq67ge+ROiYC/Po9i6Ua1jirwiPGCM2W9NRotx2p/JT6OO81TnY/yVg=' 
                
                if(params){
                    for (let k in params){
                        addr+='&'+k+'='+params[k]
                    }
                }

               addr = encodeURI(addr)

                //TODO: add post object as form data

                let formData = new FormData();
                formData.append('PostData', postObject);
                

                if(activeLog){
                    // console.log('postData --> address = ', addr)
                    // console.log('Object to post = ', postObject)
                }
            
               // let r = await fetch(addr,{headers:{"Content-Type":"application/x-www-form-urlencoded"}, body:String.raw({raw:[formData]}) , method:'POST'})
               let r = await fetch(addr,{
                method:'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                 body:JSON.stringify(postObject)  
               // body:'1;2;3;4;5'
            })
      
        //  let r = new XMLHttpRequest();
        //  r.open("POST", addr, true);
        //  r.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
        //  r.send('sssss')



                //let r = await fetch(addr,{headers:{'cacat':'cacat'} ,method:'POST', body:formData})
                let rjs = await r.json()
               // let rjs = await r.text()

                if(activeLog){
                    // console.log('postData --> server response = ', r)
                    // console.log('postData --> response Status :', r.status);
                   
                    // console.log('postData --> readable server response = ', rjs)
                }

                let sR = new ServerResponseModel()

                if(sR.statusCode(r.status)){
                    
                    
                    // console.log('response is ------- :', r);
                    return rjs
                }else{
                    console.error('error status code', r)
                }
            
         

            
        
        
    }


    getData = async (adresa,params=null, activeLog=null) => {

        let userData =  this.getUserData();

        
            let addr = this.adresaServer + adresa+'?UserToken='+'GnkLzHZdB3A1geiknDDYK8KQYrMTtxu7iq4lJzg9jLO2NZR7OrfOpxLxZf1OpCIh1mdIhLA27RRX8w2Lnb4WycPBENsvbwNL7qfVASni4WQFB4gS38BQ2HPlSNuT/bpKH0gpRV07DjLgrEKuXJzi/odh2pHf3SRdrPKxizxQO/Q0qyECFBajYq67ge+ROiYC/Po9i6Ua1jirwiPGCM2W9NRotx2p/JT6OO81TnY/yVg=' 
            
            if(params){
                for (let k in params){
                    addr+='&'+k+'='+params[k]
                }
            }

            addr = encodeURI(addr)

            if(activeLog){
                // console.log('getData --> address = ', addr)
            }

            let r = await fetch(addr)

            if(activeLog){
                // console.log('getData --> server response = ', r)
                // console.log('getData --> response Status :', r.status);
                let rjs = await r.text()
                // console.log('getData --> readable server response = ', rjs)
            }

         r = await r.json()

            return r

        
        
    }

    login = async (postObject, activeLog=null)=>{
        if(postObject){
            let addr = this.adresaServer+'Login/Loginup'

          

           addr = encodeURI(addr)

            //TODO: add post object as form data

            let formData = new FormData();
            formData.append('PostData', postObject);
            

            if(activeLog){
                // console.log('postData --> address = ', addr)
                // console.log('Object to post = ', postObject)
            }
        
           // let r = await fetch(addr,{headers:{"Content-Type":"application/x-www-form-urlencoded"}, body:String.raw({raw:[formData]}) , method:'POST'})
           let r = await fetch(addr,{
            method:'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
            body:JSON.stringify(postObject)  
        })
           
        // console.log('r :', r);

            let rjs = await r.json()

            if(activeLog){
                // console.log('postData --> server response = ', r)
                // console.log('postData --> response Status :', r.status);
               
                // console.log('postData --> readable server response = ', rjs)
            }

            let sR = new ServerResponseModel()

            if(sR.statusCode(r.status)){
                
                
                // console.log('response is ------- :', r);
                return rjs
            }else{
                console.error('error status code', r)
            }
        
            // //addr = encodeURIComponent(addr)

            // console.log("Addr = ", addr )
            // let r = await fetch(addr)
            // console.log('Login response is: ' , r )
            // console.log('Login --> response Status :', r.status);

            // let sR = new ServerResponseModel()

            // if(sR.statusCode(r.status)){

            //     let rJson = await r.json();
            //     console.log('Login text response is: ' , rJson )
    
    
            //     return rJson;
            // }else{
            //     console.error('Error Server LogIn', r.status, r.statusText)
            //     return null
            // }

           // let rJson = await r.text();
        }
    }

    generatePostObject = ()=> {
        return {
            postDataHeader:{
                Scop:null, //Select, SelectComplex, Insert, Update
                Tabela:null, // numele tabelei
                Id:null,
                Ref:null, //---- if jsTruster --- dh839dnasjddty
            },
            columns:null,  //{c1: 'id_client', c2:'nume_client'}
            where:null,        //{id: ''}
            custselect:null, //query ex = 'Select * from clienti where userToken = @p1 ' ---- SelectComplex
            custparams:null //{p1: 'blah blah'} ---- SelectComplex
        }
    }


    postToJsTruster = (postObject, params = null, activeLog = null) =>{
        let adaptedPostObject = postObject
        adaptedPostObject.postDataHeader.Ref = 'dh839dnasjddty'

        // console.log('postObject jsTruster :', postObject);

        return this.postData('JsTruster/Crud', adaptedPostObject, params, activeLog)
    }

    getUserData = ()=>{
        // let LS = new LocalStorage();
        // return LS.GetUserData();
    }
}